import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { LoadingDesktopTable } from './desktop';
import { LoadingMobileTable } from './mobile';
import { LoadingTabletTable } from './tablet';

export const ResponsiveLoadingTable: React.FC = () => {
  const loadingComponent = useBreakpointValue({
    base: <LoadingMobileTable />,
    sm: <LoadingTabletTable />,
    lg: <LoadingDesktopTable />,
  });

  return loadingComponent;
};
